export const addAccountsToGroupBulkActionType = 'addAccountsToGroup';
